/* No third-party SDKs or background requests. Sharing is always reader initiated. */
(function () {
  'use strict';

  // Match the Liquid resolver. Never fetch products or rewrite article records here.
  function productHandle(href, base) {
    try {
      var u = new URL(href, base);
      if (!/^https?:$/.test(u.protocol)) return '';
      var host = u.hostname.toLowerCase(), legacy = host === 'online-store-web.shopifyapps.com';
      var accepted = [new URL(base).hostname, 'jp-shop.kiwabi.com', 'kiwabi-japan.myshopify.com'];
      if (!legacy && accepted.indexOf(host) === -1) return '';
      var path = u.pathname.toLowerCase();
      if (legacy && path.indexOf('/shop/products/') !== 0) return '';
      if (path.indexOf('/products/') === -1) return '';
      var handle = decodeURIComponent(path.split('/products/').pop().split('/')[0]).toLowerCase();
      if (!legacy) return handle;
      var map = {'rv001-bl':'rv001','rv002-bl':'rv002','rv003-bl':'rv003','rb001-bl':'rb001','rv004':'rv004','rb002':'rb002','rb003':'rb003','rb004':'rb004'};
      return map[handle] || '';
    } catch (error) { return ''; }
  }
  function cleanLegacy(root) {
    var article = root.closest('.blog__article');
    var content = article && article.querySelector('.blog__article__content');
    if (!content) return;
    var cards = Array.from(root.querySelectorAll('[data-knn-handle]'));
    if (root.dataset.knuFeatured === 'true' && cards.length && root.dataset.knnComplete === 'true') {
      content.querySelectorAll('#news-lineup,.news-lineup-wrap,.news-lineup-item,.news-lineup-copy,.news-lineup-name,.news-lineup-price,.news-lineup-image,.news-lineup-pic,.news-lineup-detail,.news-lineup-btn').forEach(function (node) {
        node.setAttribute('data-knn-replaced', ''); node.hidden = true; node.style.setProperty('display', 'none', 'important');
      });
      root.dataset.knnLegacyChecked = 'true'; return;
    }

    var handles = new Set(cards.map(function (c) { return c.dataset.knnHandle; }));
    function empty(node) {
      return !node.textContent.trim() && !node.querySelector('img,video,iframe,a,form,input');
    }
    function hide(node, key) { node.setAttribute(key, ''); node.hidden = true; node.style.setProperty('display', 'none', 'important'); }
    function covered(nodes) {
      var anchors = [];
      nodes.forEach(function (n) {
        if (n.matches('a[href]')) anchors.push(n);
        anchors = anchors.concat(Array.from(n.querySelectorAll('a[href]')));
      });
      var productLinks = anchors.filter(function(a) {return a.getAttribute('href').toLowerCase().indexOf('/products/') !== -1;});
      return productLinks.length > 0 && productLinks.every(function(a) {return handles.has(productHandle(a.getAttribute('href'), root.dataset.knnUrl));});
    }
    content.querySelectorAll('.news-lineup-item').forEach(function (node) {
      if (empty(node)) hide(node, 'data-knn-empty');
      else if (covered([node])) hide(node, 'data-knn-replaced');
    });
    // Single-product promotions also occur as loose adjacent sibling divs.
    var parts = '.news-lineup-copy,.news-lineup-name,.news-lineup-price,.news-lineup-image,.news-lineup-pic,.news-lineup-detail,.news-lineup-btn';
    var processed = new Set();
    content.querySelectorAll(parts).forEach(function (first) {
      if (processed.has(first) || first.closest('.news-lineup-item')) return;
      var group = [], node = first;
      while (node && node.matches(parts)) {group.push(node);processed.add(node);node = node.nextElementSibling;}
      if (covered(group)) group.forEach(function (n) {hide(n, 'data-knn-replaced');});
    });
    content.querySelectorAll('.news-lineup-wrap,#news-lineup').forEach(function (node) {
      var copy = node.cloneNode(true);
      copy.querySelectorAll('[data-knn-replaced],[data-knn-empty]').forEach(function (n) {n.remove();});
      copy.querySelectorAll('h4').forEach(function(h) {if (!h.textContent.trim() || h.textContent.trim().toUpperCase() === 'LINEUP') h.remove();});
      if (empty(copy)) hide(node, 'data-knn-empty');
    });
    if (root.dataset.knnComplete !== 'true') {
      // An unresolved legacy group stays readable; avoid repeating its resolved products.
      content.querySelectorAll('.news-lineup-item:not([data-knn-replaced]):not([data-knn-empty]) a[href]').forEach(function(a) {
        var handle = productHandle(a.getAttribute('href'), root.dataset.knnUrl);
        cards.forEach(function(c) {if (c.dataset.knnHandle === handle) c.hidden = true;});
      });
      var list = root.querySelector('[data-knn-products]');
      if (list && !cards.some(function(c) {return !c.hidden;})) list.hidden = true;
    }
    root.dataset.knnLegacyChecked = 'true';
  }

  function init(root) {
    if (root.dataset.knnReady) return;
    root.dataset.knnReady = 'true';
    cleanLegacy(root);
    var ja = root.dataset.knnLanguage === 'ja';
    var url = root.dataset.knnUrl;
    var title = root.dataset.knnTitle;
    var copy = root.querySelector('[data-knn-copy]');
    var native = root.querySelector('[data-knn-native]');
    var fallback = root.querySelector('[data-knn-fallback]');
    var input = fallback.querySelector('input');
    var status = root.querySelector('[data-knn-status]');
    var data = { title: title, text: title, url: url };
    function manual() {
      fallback.hidden = false;
      fallback.open = true;
      input.focus();
      input.select();
      input.setSelectionRange(0, input.value.length);
      status.textContent = ja ? 'URLを選択しました。コピーして共有してください。' : 'The URL is selected. Copy it to share.';
    }
    copy.hidden = false;
    fallback.hidden = true;
    copy.addEventListener('click', async function () {
      status.textContent = '';
      try {
        if (!navigator.clipboard || !navigator.clipboard.writeText) { manual(); return; }
        await navigator.clipboard.writeText(url);
        status.textContent = ja ? 'URLをコピーしました。' : 'Link copied.';
      } catch (error) { manual(); }
    });
    var canShare = typeof navigator.share === 'function';
    try { if (navigator.canShare) canShare = canShare && navigator.canShare(data); }
    catch (error) { canShare = false; }
    native.hidden = !canShare;
    native.addEventListener('click', async function () {
      status.textContent = '';
      native.disabled = true;
      try { await navigator.share(data); }
      catch (error) {
        if (!error || error.name !== 'AbortError') {
          status.textContent = ja ? '共有画面を開けませんでした。SNSボタンまたはURLのコピーをご利用ください。' : 'Unable to open sharing. Use a social button or copy the link.';
        }
      } finally { native.disabled = false; }
    });
  }
  function scan(scope) { scope.querySelectorAll('[data-knn-bottom]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
}());
